import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';

export type Country = {
  id: number;
  iso: string;
  name: string;
};

export type GetCountriesResponse = {
  countries: Country[];
};

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  private countriesPromise?: Promise<GetCountriesResponse>;

  async getCountries(): Promise<GetCountriesResponse> {
    if (!this.countriesPromise) {
      const url = `${environment.baseUrl}/api/country`;
      this.countriesPromise = axios
        .get<GetCountriesResponse>(url)
        .then((result) => result.data);
    }

    return this.countriesPromise;
  }
}
